import { render, staticRenderFns } from "./notOrder.vue?vue&type=template&id=3a8bcd14&scoped=true"
import script from "./notOrder.vue?vue&type=script&lang=js"
export * from "./notOrder.vue?vue&type=script&lang=js"
import style0 from "./notOrder.vue?vue&type=style&index=0&id=3a8bcd14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bcd14",
  null
  
)

export default component.exports